module.exports = __webpack_public_path__ + "static/bg3-e92b478f8b51e3d55d45af2fec584b07.jpg";